import * as yup from "yup";
import { GenerateAdminApiSecretFormValues } from "./types";

export const defaultFormValues: GenerateAdminApiSecretFormValues = {
  id: undefined,
  name: "",
};

export const schema = yup.object().shape({
  id: yup.string().nullable().optional(), // or yup.mixed() if it could be other than string
  name: yup.string().required("Name is required"),
});
